<br style="margin: 10px 10px 10px 10px;">
<div class="-oneX-container">
    <div class="-oneX-row -oneX-justify-content-center">
        <div tabindex="0" class="-oneX-icon-container" style="height:32px;width:32px">
            <div class="-oneX-icon -oneX-icon--variant1" data-icon="error_32" style="height:32px;width:32px"> </div>
        </div>
        <div>&nbsp;</div>
        <div class="-oneX-body--intro" style="margin-right: 15px;">Internal
            server error, please try again later.</div>
    </div>
</div>